import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { persistStore, autoRehydrate } from "redux-persist";
import { createFilter /*, /createBlacklistFilter*/ } from "redux-persist-transform-filter";

import { setPersisted } from "./actions/persist";
import { userCheckLogin } from "./actions/user";

export default function configureStore(preloadedState = {}) {
	// const initialState = {}
	const enhancers = [];
	enhancers.push(autoRehydrate());

	const middleware = [
		thunk
		// routerMiddleware(history)
	];

	if (process.env.NODE_ENV === "development" && process.env.DEBUGGER_ENV !== "false") {
		const devToolsExtension = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;

		if (typeof devToolsExtension === "function") {
			enhancers.push(devToolsExtension());
		}
	}

	const composedEnhancers = compose(
		applyMiddleware(...middleware),
		...enhancers
	);

	// Load either passed in state, or localStorage state
	const persistedState = preloadedState !== {} ? preloadedState : {}; // : loadState()

	const store = createStore(rootReducer, persistedState, composedEnhancers);

	if (process.env.NODE_ENV !== "production" && process.env.DEBUGGER_ENV !== "false") {
		if (module.hot) {
			module.hot.accept("./reducers", () => {
				store.replaceReducer(rootReducer);
			});
		}
	}

	// Only persist the users themselves (not errors)
	const userFilter = createFilter("user", ["admin", "reviewer", "loginTokens"]);

	// Only persist useful data for enews
	// const eNewsFilter = createFilter("enews", ["success"]);

	// Blacklist un-usefull stuff
	// const cartBlacklistFilter = createBlacklistFilter("cart", ["couponInProcess", "couponError", "couponSuccess", "couponDeleteError", "inProccess", "success"]);

	// ===================================
	//  Can only persist on client... yay... :/
	//  As far as I can tell, that means the server has no idea if the user is logged in or not
	// ===================================
	if (typeof window !== "undefined") {
		persistStore(
			store,
			{
				whitelist: ["user"],
				transforms: [userFilter]
			},
			() => {
				// Once store has persisted, let the app know about it
				const promises = [
					store.dispatch(userCheckLogin("reviewer")),
					store.dispatch(userCheckLogin("admin"))
				];
				Promise.all(promises).then(() => {
					store.dispatch(setPersisted());
					// console.log("PERSISTSED:", store.getState());
				});
			}
		);
	}

	// console.log("configureStore():", store.getState());

	return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js